import { ReloadOutlined, SearchOutlined } from "@ant-design/icons";
import React, { useEffect,useState } from "react";
import { Button, Pagination, Select, Tooltip } from "antd";
import { apiurls } from "../../resources/APIurls";
import { appconfig } from "../../resources/config";
import axios from "axios";
import { ToolTipContent } from "../../resources/tooltip";
import { SoilDropDownData } from "../../resources/SoilDrawerContent/SoilDropDownData";
import {
  getData,
} from "../../resources/utils";
const { Option } = Select;

const LocationHeader = ({
  locationFiltersList,
  setLocationFiltersList,
  locationFilters,
  setLocationFilters,
  featureType,
  setFeatureType,
  farmName,
  setCurrentPage,
  farmMobileNum,
  searchDisable,
  setFetchingFarms,
  farmsPaginataion,
  setFarmsPaginataion,
  allFarms,
  setAllFarms,
  setFarmCount,
  setFarmsCount,
  setMapLoader,
  selectedSeason,
  setSelectedSeason,
  selectedSoilNutrient,
  setSelectedSoilNutrient,
  seasonsList,
  dropdownLoader,
  setDropdownLoader,
  handleSearch,
  resetFilters,
  getCropHistoryYieldAreaData,
  clearSoilDataLegend
}) => {
  const getAllFarms = async (page, farmName, mobileNum) => {
    setMapLoader(true);
    let apikey = apiurls.find((item) => item.apikey === "geotaggedfarms");
    setFetchingFarms(true);
    const res = await axios({
      method: "GET",
      url: `${appconfig.domain[appconfig.environment].geotaggedfarms}${
        apikey.paths.geotaggedfarms
      }`,
      headers: {
        "Client-Name": "IOS_REACT_NATIVE_APP",
        "Client-Token": localStorage.getItem("token"),
        "X-localization": "en",
      },
      params: {
        customer_type: "web",
        offset: page,
        limit: 20,
        search: farmName,
        mobile: mobileNum,
        sort: "created_at",
        sort_order: "DESC",
      },
    });

    if (farmName === "" && mobileNum === "") {
      setAllFarms(res.data.data);
      setFarmsPaginataion(Math.ceil(res.data.recordsTotal / 20));
    } else if (farmName !== "") {
      setAllFarms(res.data.data);
      setFarmsPaginataion(Math.ceil(res.data.recordsTotal / 20));
    } else {
      setAllFarms(res.data.data);
    }

    setFarmCount(res.data);
    setFetchingFarms(false);
    setMapLoader(false);
  };

 const [featureTypesList, setFeatureTypesList] = React.useState([]);
const geLocationtList = async (params = {}, stateSetter = null, loaderSetter = () => {}) => {
  loaderSetter(true);
  if (stateSetter) {
    const resetMap = {
      state: ["state", "city", "taluka", "village", "khasra"],
      city: ["city", "taluka", "village", "khasra"],
      taluka: ["taluka", "village", "khasra"],
      village: ["village", "khasra"],
      khasra: ["khasra"],
    };
    const keys = resetMap[stateSetter] || [];
    const obj = { ...locationFiltersList };
    keys.forEach((k) => (obj[k] = []));
    setLocationFiltersList(obj);
  }

  try {
    const res = await getData(
      "agribhumi",
      "users_role",
      {
        user_id: localStorage.getItem("user_id"),
        type: params?.type || "feature",
        ...params,
      },
      null
    );

    if (stateSetter) {
      setLocationFiltersList({
        ...locationFiltersList,
        [stateSetter]: res.data.data,
      });
    }

    return res;

  } catch (err) {
    console.error(err);
    return null;
  } finally {
    loaderSetter(false);
  }
};

useEffect(() => {
  const fetchFeatures = async () => {
    const res = await geLocationtList(); 
    if (res && res.data && Array.isArray(res.data.data)) {
      setFeatureTypesList(res.data.data); 
    } else {
      setFeatureTypesList([]); 
    }
  };

  fetchFeatures();
}, []);

  const manageUpperCaseString = (str) => {
    let lower = str.toLowerCase();
    return lower.charAt(0).toUpperCase() + lower.slice(1);
  };

  const resetFiltersBtn = () => {
    resetFilters();
  };

  const handleSearchBtn = () => {
    handleSearch();
  };

  useEffect(() => {
  if (
    featureType === 6 ||
    featureType === 1 ||
    featureType === "crop-history" ||
    featureType === 5
  ) {
    setLocationFilters({
      ...locationFilters,
      country: null,
      state: null,
      city: null,
      taluka: null,
      village: null,
      khasra: null,
    });

    setLocationFiltersList({
      ...locationFiltersList,
      state: [],
      city: [],
      taluka: [],
      village: [],
      khasra: [],
    });
  }
  if (
    featureType === 6  ||
    featureType === 1 ||
    featureType === "crop-history" ||
    featureType === 5
  ) {
  } else {
  }
}, [featureType]);





// Tooltips content
const ToolTipContent = {
  "Farmer Score Card":
    "A score provided based on the performance and profitability of previous years records.",
  "LULC": "Land Use / Land Cover data",
  "Crop Data": "Crop information data",
  "Soil Data": "Soil data",
  "Cadastral Data": "Farm boundaries with ownership and khasra details of land parcel.",
  "Farm Report":
    "Farm record with details of ownership, available nutrients in the soil, and crop history from the previous year.",
  "Farmer Advisory": "Advisory information for farmers",
  "Analytics": "Analytics dashboard",
  "Agribazaar App": "Geotagged farm",
};


  return (
    <>
      <Select
        className="dropdown"
        placeholder="Select Feature Type"
        value={featureType}
        onChange={async (val) => {
          setFeatureType(val);
          const farmCheckIds = [1, 5, 6];

          const params = {
            type: "country",
            ...(farmCheckIds.includes(val) && { farm_check: 2 }),
          };
          const res = await geLocationtList(
            params,
            null,
            setDropdownLoader
          );
          if (res && res.data && Array.isArray(res.data.data)) {
            setLocationFiltersList((prev) => ({
              ...prev,
              country: res.data.data,
            }));
          }
        }}
        loading={dropdownLoader}
      >
        {featureTypesList?.map((item) => (
          <Option key={item.id} value={item.id}>
            <Tooltip placement="right">
              {item.name}
            </Tooltip>
          </Option>
        ))}
      </Select>

      {featureType !== 9 ? (
        <>
          {featureType === 3 && seasonsList.data?.length > 0 && (
            <Select
              className="dropdown"
              placeholder="Select Season"
              value={selectedSeason.season_id}
              onSelect={(val, option) => {
                setSelectedSeason({
                  season_name: option.children,
                  season_id: val,
                });
                // getCropHistoryYieldAreaData(option.children);
              }}
              allowClear
            >
              {seasonsList.data.map(
                (item, index) =>
                  item.season_name !== null && (
                    <Option key={index} value={item.season_id}>
                      {item.season_name}
                    </Option>
                  )
              )}
            </Select>
          )}
          {featureType === 4 && seasonsList.data?.length > 0 && (
            <Select
              className="dropdown"
              placeholder="Select Nutrient"
              value={selectedSoilNutrient}
              onSelect={(val) => {
                setSelectedSoilNutrient(val);
                clearSoilDataLegend()
              }}
            >
              {SoilDropDownData?.map((item) => (
                <option key={item.key} value={item.value}>
                  {item.name}
                </option>
              ))}
            </Select>
          )}
          <Select
            showSearch
            allowClear
            placeholder="Select Country*"
            className="dropdown"
            loading={dropdownLoader && !locationFiltersList.country?.length}
            value={locationFilters.country?.code}

            onChange={async (val) => {
              if (val) {
                const farmCheckIds = [1, 5, 6];
                const params = {
                  user_id: localStorage.getItem("user_id"),
                  type: "state",
                  country_id: val,
                  ...(farmCheckIds.includes(featureType) && { farm_check: 2 }),
                };
                const res = await geLocationtList(
                  params,
                  "state",
                  setDropdownLoader
                );
                if (res && res.data && Array.isArray(res.data.data)) {
                  setLocationFiltersList((prev) => ({
                    ...prev,
                    state: res.data.data,
                  }));
                }
              } else {
                setLocationFilters({
                  ...locationFilters,
                  country: null,
                  state: null,
                  city: null,
                  taluka: null,
                  village: null,
                  khasra: null,
                });
                setLocationFiltersList((prev) => ({
                  ...prev,
                  state: [],
                  city: [],
                  taluka: [],
                  village: [],
                  khasra: [],
                }));
              }
            }}
            onSelect={(val, option) => {
              setLocationFilters({
                ...locationFilters,
                country: { label: option.children, code: val },
                state: null,
                city: null,
                taluka: null,
                village: null,
                khasra: null,
              });
            }}
          >
            {Array.isArray(locationFiltersList.country) &&
              locationFiltersList.country.map((item) => (
                <Option key={item.country_id} value={item.country_id}>
                  {item.country_name}
                </Option>
              ))}
          </Select>
          <Select
            showSearch
            allowClear
            filterOption={(input, option) =>
              option.children.toLowerCase().includes(input.toLowerCase())
            }
            placeholder="Select State*"
            className="dropdown"
            loading={dropdownLoader && !locationFiltersList.state?.length}
            value={locationFilters.state?.code}
            onChange={async (val) => {
              if (val) {
                const farmCheckIds = [1, 5, 6];
                const params = {
                  user_id: localStorage.getItem("user_id"),
                  type: "district",
                  state_id: val,
                  ...(farmCheckIds.includes(featureType) && { farm_check: 2 }),
                };
                const res = await geLocationtList(
                  params,
                  "city",
                  setDropdownLoader
                );
                if (res && res.data && Array.isArray(res.data.data)) {
                  setLocationFiltersList((prev) => ({
                    ...prev,
                    city: res.data.data,
                  }));
                }

              } else {
                setLocationFilters((prev) => ({
                  ...prev,
                  state: null,
                  city: null,
                  taluka: null,
                  village: null,
                  khasra: null,
                }));

                setLocationFiltersList((prev) => ({
                  ...prev,
                  city: [],
                  taluka: [],
                  village: [],
                  khasra: [],
                }));
              }
            }}

            onSelect={(val, option) => {
              setLocationFilters((prev) => ({
                ...prev,
                state: { label: option.children, code: val },
                city: null,
                taluka: null,
                village: null,
                khasra: null,
              }));
            }}
          >
            {Array.isArray(locationFiltersList.state) &&
              locationFiltersList.state.map((item) => (
                <Option key={item.state_code} value={item.state_code}>
                  {item.state_name}
                </Option>
              ))}
          </Select>
          <Select
            showSearch
            filterOption={(input, option) =>
              option.children.toLowerCase().includes(input.toLowerCase())
            }
            placeholder={
              locationFilters.country?.code == "2"
                ? "Select LGA*"
                : "Select City*"
            }
            allowClear
            className="dropdown"
            loading={dropdownLoader && !locationFiltersList.city.length}
            value={locationFilters.city?.code}
            onChange={async (val) => {
              if (val) {
                const farmCheckIds = [1, 5, 6];
                const params = {
                  user_id: localStorage.getItem("user_id"),
                  type: "taluk",
                  district_id: val,
                  ...(farmCheckIds.includes(featureType) && { farm_check: 2 }),
                };
                const res = await geLocationtList(
                  params,
                  "taluka",
                  setDropdownLoader
                );

                if (res && res.data && Array.isArray(res.data.data)) {
                  setLocationFiltersList((prev) => ({
                    ...prev,
                    taluka: res.data.data,
                  }));
                }

              } else {
                setLocationFilters((prev) => ({
                  ...prev,
                  city: null,
                  taluka: null,
                  village: null,
                  khasra: null,
                }));

                setLocationFiltersList((prev) => ({
                  ...prev,
                  taluka: [],
                  village: [],
                  khasra: [],
                }));
              }
            }}
            onSelect={(val, option) => {
              setLocationFilters({
                ...locationFilters,
                city: {
                  label: option.children,
                  code: val,
                },
                taluka: null,
                village: null,
                khasra: null,
              });
            }}
          >
            {locationFiltersList.city.length &&
              locationFiltersList.city.map((item, index) => (
                <Option key={index} value={item.district_code}>
                  {item.district_name}
                </Option>
              ))}
          </Select>
          <Select
            allowClear
            showSearch
            filterOption={(input, option) =>
              option.children.toLowerCase().includes(input.toLowerCase())
            }
            loading={dropdownLoader && !locationFiltersList.taluka?.length}
            placeholder={
              locationFilters.country?.code == "2"
                ? "Select Ward"
                : "Select Taluka"
            }
            className="dropdown"
            value={locationFilters.taluka?.code}

            onChange={async (val) => {
              if (val) {
                const farmCheckIds = [1, 5, 6];
                const params = {
                  user_id: localStorage.getItem("user_id"),
                  type: "village",
                  taluk_id: val,
                  ...(farmCheckIds.includes(featureType) && { farm_check: 2 }),
                };
                const res = await geLocationtList(params, "village", setDropdownLoader);
                if (res && res.data && Array.isArray(res.data.data)) {
                  setLocationFiltersList((prev) => ({
                    ...prev,
                    village: res.data.data,
                  }));
                }

              } else {
                setLocationFilters((prev) => ({
                  ...prev,
                  taluka: null,
                  village: null,
                  khasra: null,
                }));

                setLocationFiltersList((prev) => ({
                  ...prev,
                  village: [],
                  khasra: [],
                }));
              }
            }}

            onSelect={(val, option) => {
              setLocationFilters((prev) => ({
                ...prev,
                taluka: { label: option.children, code: val },
                village: null,
                khasra: null,
              }));
            }}
          >
            {Array.isArray(locationFiltersList.taluka) &&
              locationFiltersList.taluka.map((item) => (
                <Option key={item.taluk_code} value={item.taluk_code}>
                  {item.taluk_name}
                </Option>
              ))}
          </Select>
          {locationFilters.country != null &&
            locationFilters.country.code != "2" && (
              <>
                <Select
                  allowClear
                  showSearch
                  loading={dropdownLoader && !locationFiltersList.village?.length}
                  filterOption={(input, option) =>
                    option.children.toLowerCase().includes(input.toLowerCase())
                  }
                  className="dropdown"
                  placeholder="Select Village"
                  value={locationFilters.village?.code}

                  onChange={async (val) => {
                    if (val) {
                      const farmCheckIds = [1, 5, 6];

                      const params = {
                        user_id: localStorage.getItem("user_id"),
                        type: "khasra",
                        village_code: val,
                        ...(farmCheckIds.includes(featureType) && { farm_check: 2 }),
                      };

                      const res = await geLocationtList(params, "khasra", setDropdownLoader);

                      if (res && res.data && Array.isArray(res.data.data)) {
                        setLocationFiltersList((prev) => ({
                          ...prev,
                          khasra: res.data.data,
                        }));
                      }

                    } else {
                      setLocationFilters((prev) => ({
                        ...prev,
                        village: null,
                        khasra: null,
                      }));

                      setLocationFiltersList((prev) => ({
                        ...prev,
                        khasra: [],
                      }));
                    }
                  }}

                  onSelect={(val, option) => {
                    setLocationFilters((prev) => ({
                      ...prev,
                      village: {
                        label: option.children,
                        code: val,
                      },
                      khasra: null,
                    }));
                  }}
                >
                  {Array.isArray(locationFiltersList.village) &&
                    locationFiltersList.village.map((item) => (
                      <Option key={item.agbr_village_code} value={item.agbr_village_code}>
                        {manageUpperCaseString(item.village_name)}
                      </Option>
                    ))}
                </Select>
                <Select
                  allowClear
                  showSearch
                  loading={
                    dropdownLoader && !locationFiltersList.khasra?.length
                  }
                  filterOption={(input, option) =>
                    option.children
                      .toString()
                      .toLowerCase()
                      .includes(input.toString().toLowerCase())
                  }
                  className="dropdown"
                  placeholder="Select Khasra"
                  value={locationFilters.khasra?.label}
                  onChange={(val) => {
                    if (!val) {
                      setLocationFilters({
                        ...locationFilters,
                        khasra: null,
                      });
                    }
                  }}
                  onSelect={(val, option) => {
                    if (val) {
                      setLocationFilters({
                        ...locationFilters,
                        khasra: { label: option.children, code: val },
                      });
                    } else {
                      setLocationFilters({
                        ...locationFilters,
                        khasra: null,
                      });
                    }
                }}
              >
                {locationFiltersList.khasra?.length > 0 &&
                  [...locationFiltersList.khasra]
                    .sort((a, b) => Number(a.khasra) - Number(b.khasra))
                    .map((item, index) => (
                      <Option key={index} value={item.id}>
                        {item.khasra}
                      </Option>
                    ))}
              </Select>
            </>
            )}
          <Button
            shape="circle"
            icon={<SearchOutlined />}
            className="resetBtn"
            onClick={handleSearchBtn}
            style={{ marginLeft: "2%" }}
            disabled={searchDisable}
          />
          <Button
            style={{ marginLeft: "0px", marginRight: "24px" }}
            shape="circle"
            icon={<ReloadOutlined />}
            className="resetBtn"
            onClick={resetFiltersBtn}
            disabled={searchDisable}
          />
        </>
      ) : (
        <div
          style={{
            display: "flex",
            alignItems: "center",
            width: "100%",
            justifyContent: "space-around",
            marginLeft: "2%",
          }}
        >
              {allFarms.length > 0 && (
                <div>
                  <Pagination
                    className="ant-pagination-item ant-pagination-item"
                    size="small"
                    showQuickJumper
                    defaultCurrent={1}
                    total={farmsPaginataion * 10}
                    style={{ color: "#ffffff" }}
                    onChange={(page, pageSize, event) => {
                      setFarmsCount(true);
                      getAllFarms(page * 20 - 20, farmName, farmMobileNum);
                      setCurrentPage(page * 20 - 20);
                    }}
                  />
                </div>
              )}
            </div>
      )}
    </>
  );
};

export default LocationHeader;
